import React from 'react';

import routes from 'modules/Layouts/routes';
import SectionpageCard from 'components/SectionPageCard';

let MenuPage: React.FC = (props: any) => {
	let route = routes.find((route) => route.name === 'menu');

	return (
		<div className="sectionPage">
			{route?.subroutes.map((subroute) => (
				<SectionpageCard subroute={subroute} key={`${subroute.path}-card`} />
			))}
		</div>
	);
};

export default MenuPage;
